/**
 * SubmissionGrundDialog — shared Grund prompt for «nicht offeriert» (Grund optional) and «inaktiv
 * markieren» (Grund required, min 3). P2 Placement Slice 8.
 */

import { useState } from 'react';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

export function SubmissionGrundDialog({
  open,
  onClose,
  title,
  grundRequired,
  submitLabel,
  pending,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  grundRequired: boolean;
  submitLabel: string;
  pending: boolean;
  onSubmit: (grund: string) => void;
}) {
  const [grund, setGrund] = useState('');
  const tooShort = grundRequired && grund.trim().length < 3;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>
            Abbrechen
          </Button>
          <Button
            disabled={pending || tooShort}
            onClick={() => onSubmit(grund.trim())}
            data-testid="sub-grund-submit"
          >
            {pending ? 'Wird gespeichert …' : submitLabel}
          </Button>
        </div>
      }
    >
      <label className="flex flex-col gap-1 text-sm">
        <span className="text-muted-foreground">Grund {grundRequired ? '(erforderlich)' : '(optional)'}</span>
        <textarea
          className="min-h-[88px] rounded-md border border-border bg-background p-2 text-sm"
          value={grund}
          maxLength={2000}
          onChange={(e) => setGrund(e.target.value)}
          data-testid="sub-grund-input"
        />
      </label>
    </Dialog>
  );
}
